import { createSlice } from '@reduxjs/toolkit';

export type PinState = Record<string, boolean>;

const initialState: PinState = {};

export const pinSlice = createSlice({
    name: 'pin',
    initialState,
    reducers: {
        pin: (state, action) => {
            state[action.payload] = true;
        },
        unpin: (state, action) => {
            state[action.payload] = false;
        },
        set: (state, action) => action.payload,
    },
});

export const pinSelectors = {
    isPinned: (state: PinState, id: string) => state[id],
};
